angular.module('wbDashboard').controller('PlansDetailPortfolioplusControllerAurea',
    ['$scope', '$uibModal', '$filter', 'User', 'Milestone', 'PlanService', 'RiskScore', 'DataService', 'ThinkingService',
function ($scope, $uibModal, $filter, User, Milestone, PlanService, RiskScore, DataService, ThinkingService) {

    if (gotoFeature()) {
        return false;
    }

    $scope.pageData.actionNavOffset = 0;

    RiskScore.retrievePortfolios();

    $scope.corePortfolio = RiskScore.getCorePortfolio();

    PlanService.retrievePortfolios('themed');
    $scope.$watch(function() { return PlanService.getPortfolios('themed'); }, function(portfolios) {
        if (portfolios) {
            $scope.defaultPortfolios = portfolios.list;
            $scope.featured = portfolios.featured;
        }
    });

    $scope.milestoneChoices = null;
    $scope.$watchCollection(function() { return User.getMilestones(); }, function(milestones) {
        if (milestones) {
            $scope.milestoneChoices = {};
            var p, promises = [];
            angular.forEach(milestones, function(ms) {
                ms.extra.portfolioName = PlanService.user.getPortfolioName(ms.allocation.allocation_model);
                ms.extra.portfolioImgAsset = PlanService.user.getPortfolioImgAsset(ms.allocation.allocation_model);
                if (ms.type === "cash") { // || ms.allocation.allocation_model === "0.0") {
                    ms.extra.isCash = true;
                }
                $scope.milestoneChoices[ms.id] = ms;


                //when retrieveAllMilestones is called, recommendations lost, need to retrieve again...
                if ( 1  //(!ms.allocation.recommendation || !Object.keys(ms.allocation.recommendation).length || !ms.allocation.recommendation.allocation_start)
                    && !['wallet','cash'].includes(ms.type) ) {
                    p = Milestone.retrieveGlideRecommend({
                        milestone_type: ms.type_real,
                        life_expectancy: ms.metadata.life_expectancy,
                    }).then(function(glideRecommend) {
                        ms.allocation.recommendation = glideRecommend;
                    });
                    promises.push(p);
                }

            });
        }
    });

    $scope.portfolios = null;
    $scope.$watch(function() { return PlanService.user.getPortfolios(); }, function(portfolios) {
        if (portfolios && Object.keys(portfolios).length) {
            $scope.portfolios = portfolios;
        } else {
            $scope.portfolios = null;
        }
    }, true);

    $scope.riskPortfolios = null;
    $scope.$watch(function() { return RiskScore.getPortfolios(); }, function(portfolios) {
        if (portfolios) {
            $scope.riskPortfolios = angular.copy(portfolios);
        }
    });

    $scope.assets = null;
    DataService.retrieveAssetClasses();
    $scope.$watch(function() { return DataService.getAssetClasses(); }, function(assets) {
        if (assets) {
            $scope.assets = assets;
        }
    });






















    $scope.confirmFeatures.initial = function() {
        //check what's can be enabled, enable it, create array of edits to go through
        ThinkingService.open($scope, "portfolioplus", {thinking:"Activating Portfolio Plus Features", complete:"Portfolio Plus Activated!"});
        var featureWatch = $scope.$watch('featureInit', function(featureInit) {
            if (featureInit) {
                angular.forEach($scope.featureInit, function(enabled, featureSlug) {
                    switch (featureSlug) {
                        case 'customportfolio':
                            $scope.featureInit[featureSlug] = true;
                            break;
                    }
                });
                $scope.confirmFeatures().then(function() {
                    ThinkingService.close(false, "portfolioplus");
                });

                //disable watcher
                featureWatch();
            }
        });

    };

    $scope.confirmFeatures.complete = function() {
        $scope.$state.go('base.plans.custom.portfolioplus', {fslug:"customportfolio", location: "replace"});
    };

    function gotoFeature() {
        if ($scope.$state.current.name.indexOf("base.plans.detail.plan.init") === -1) {
            //load entire controller on init or confirmFeatures.initial won't be loaded or run in time
            if ($scope.$state.current.name.indexOf("base.plans.detail.plan") > -1) {
                return $scope.$state.go('base.plans.custom.portfolioplus', {location: "replace"});
            }
        }
        return false;
    }

    var transitionDeregisterHook = $scope.$transitions.onStart({ to: "base.plans.detail.plan.**" }, function(trans) {
        return gotoFeature();
    });
    $scope.$on('$destroy', function() {
        if (transitionDeregisterHook) {
            transitionDeregisterHook();
        }
    });

}]);
